import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG, MODAL_md } from '../../../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../../../theme/Component/Modal';
import { BasicTable } from '../../../../../../../theme/Component/BasicTable';
import { OBsEditor } from '../../../../../../../contract/etapa-contrato/contrac/UBLInvoiceSupplier/Component/OBsEditor';
import { AccountEditor } from '../../../../../../../editor/AccountEditor';
import { InputDate } from '../../../../../../../theme/Input/InputDate';
import { _single } from '../../../../../../../../core/services/dataBean/EntityCatalog';
import { BasicButton } from '../../../../../../../theme/Component/BasicButton';
import { _ObligationBudget } from '../../../../../../../../core/services/dataBean/EntityCatalogVdos';
import { PrintJson } from '../../../../../../../theme/Component/PrintJson';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
    IDAccount?: any;
}

export const ObligationBudget = ({ idSelector, onChange, label, returnType = "ID", render, IDAccount }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ObligationBudget)
    const [id, setID] = useState(null);
    const [obseditor, setobseditor] = useState<any>({
        IDDocument: NaN,
        DocumentDate: NaN,
    })
    const [account, setaccount] = useState<any>(null)
    const [paymentdate, setpaymentdate] = useState<any>(_single.getCurrenDate())
    const modal = useModal("Obligaciones Presupuestales", MODAL_LG);
    useEffect(() => {
        if (IDAccount) {
            setaccount(IDAccount);
        }
    }, [IDAccount]);
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [obseditor])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getObligationBudgetDocumentBudgetList(obseditor.IDDocument, obseditor.DocumentDate).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'Rubro Prespuestal', property: 'BudgetIDName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente Presupuestal', property: 'BudgetSourceName', visible: true },
        { title: 'Valor Obligación', property: 'OBValue', visible: true },

    ]
    const abrirModal = () => {
        setaccount(null)
        setLista(null)
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Obligaciones Presupuestales"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    {/* <PrintJson json={IDAccount} /> */}
                    <div className="col-md-12">
                        <strong>Seleccione un Beneficiario previamente y una Obligación para Continuar</strong>
                    </div>
                    <div className="col-md-4">
                        <AccountEditor idAccount={IDAccount} onChange={(e) => { setaccount(e.IDAccount) }} label="Tercero" />
                    </div>
                    <div className="col-md-4">
                        <InputDate name="date" label="Fecha del Documento" value={paymentdate} setDate={(e: any) => { setpaymentdate(e) }} />
                    </div>


                    <div className="col-md-4">

                        <OBsEditor configProps={{ label: "Obligacion Presupuestal" }} idAccount={account ?? IDAccount} paymentDate={paymentdate} onChange={(e) => {
                            setobseditor({
                                ...obseditor,
                                "IDDocument": e.IDDocument,
                                "DocumentDate": e.DocumentDate,
                            })
                        }} />
                    </div>



                </div>
                {obseditor &&
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e); modal.close(); }}></BasicTable>
                            </div>
                        </div>
                    </>
                }

            </Modal>
        </>
    )
}